<template>
  <div
    class="position-relative d-flex flex-column"
    :class="active === 2 ? 'bg-face-detect cs-steps' : 'bg-gray'"
  >
    <div class="step-container">
      <template v-for="(step, index) in steps" :key="index">
        <div
          class="step"
          :class="{ active: active === index }"
          @click="setStep(index)"
        >
          <p class="step-number">{{ index + 1 }}</p>
          <p class="step-name">{{ $t(step) }}</p>
        </div>
        <!-- Thêm đường line giữa các bước (Không hiển thị sau bước cuối cùng) -->
        <div
          v-if="index < steps.length - 1"
          class="step-line"
          :class="{ active: active > index }"
        ></div>
      </template>
    </div>

    <!-- Start Step  -->
    <div
      v-if="active === 0"
      class="d-flex flex-column flex-grow-1 overflow-hidden"
    >
      <div class="d-flex justify-content-center">
        <p class="text-white opacity-75 font-size-12">
          {{ $t("esim_place_card_correctly") }}
        </p>
      </div>

      <!-- Bọc toàn bộ phần dưới trong 1 div flex-grow-1 để chiếm phần còn lại -->
      <div class="d-flex flex-column flex-grow-1 overflow-hidden">
        <!-- Camera chiếm phần lớn chiều cao -->
        <div
          class="d-flex justify-content-center flex-grow-1 cs-camera w-100 align-items-center"
        >
          <Camera
            v-if="!imgPassport"
            ref="camera"
            @photoCaptured="handlePhotoCaptured"
          />
        </div>

        <GuideCapture :type="1" />

        <div class="d-flex justify-content-center">
          <button
            v-if="!imgPassport"
            @click="capturePhoto"
            class="btn-capture-photo my-4"
          ></button>
        </div>
      </div>
    </div>
    <div v-if="imgPassport && active === 0" class="capture-screen">
      <CaptureScreen
        :image="imgPassport"
        @retake="retakePhoto"
        @continue="continueProcess"
        :activeStep-="active"
      />
    </div>
    <!-- End Step 1 -->

    <!-- Start Step 2 -->
    <div
      v-if="active === 1"
      class="d-flex flex-column flex-grow-1 overflow-hidden"
    >
      <div class="d-flex justify-content-center">
        <p class="text-white opacity-75 font-size-12">
          {{ $t("esim_place_card_correctly") }}
        </p>
      </div>

      <!-- Bọc toàn bộ phần dưới trong 1 div flex-grow-1 để chiếm phần còn lại -->
      <div class="d-flex flex-column flex-grow-1 overflow-hidden">
        <!-- Camera chiếm phần lớn chiều cao -->
        <div
          class="d-flex justify-content-center flex-grow-1 cs-camera w-100 align-items-center"
        >
          <Camera
            v-if="!imgVisa"
            ref="camera"
            @photoCaptured="handlePhotoCaptured"
          />
        </div>

        <GuideCapture :type="1" />

        <div class="d-flex justify-content-center">
          <button
            v-if="!imgVisa"
            @click="capturePhoto"
            class="btn-capture-photo my-4"
          ></button>
        </div>
      </div>
    </div>
    <div v-if="imgVisa && active === 1" class="capture-screen">
      <CaptureScreen
        :image="imgVisa"
        @retake="retakePhoto"
        @continue="continueProcess"
        :activeStep-="active"
      />
    </div>
    <!-- End Step 2 -->

    <!-- Start Step 3 -->
    <div v-if="active === 2">
      <FaceAuth ref="faceIdComponent" @base64Image="handleChildBase64Image" />
    </div>
    <!-- End Step 3 -->
  </div>
</template>

<script>
import { Button, Image } from "vant";
import Camera from "@/components/ui/Camera/Camera.vue";
import CaptureScreen from "@/components/ui/Camera/CaptureScreen.vue";
import GuideCapture from "@/components/ui/Camera/GuideCapture.vue";
import FaceAuth from "@/components/ui/Camera/FaceAuth.vue";
import { mapState } from "vuex";
import { CONSTANTS } from "@/helpers/constants";

export default {
  name: "passport",
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
    Camera,
    CaptureScreen,
    GuideCapture,
    FaceAuth,
  },
  data() {
    return {
      active: 0,
      steps: ["esim_front_side", "esim_visa_picture", "esim_face_detect"],
      itemPassport: null,
      itemFaceId: null,
      imgIdCard: null,
      imgFaceId: null,
      imgPassport: null,
      imgVisa: null,
      isShowCardInfo: false,
    };
  },
  created() {
    this.itemPassport = this.itemPassportStore ? this.itemPassportStore : null;
    this.imgPassport = this.imgPassportStore ? this.imgPassportStore : null;

    this.imgVisa = this.imgVisaStore ? this.imgVisaStore : null;

    this.itemFaceId = this.itemFaceIdStore ? this.itemFaceIdStore : null;
    this.imgFaceId = this.imgFaceIdStore ? this.imgFaceIdStore : null;
  },
  computed: {
    ...mapState("userStore", ["profile", "defaultParam"]),
    ...mapState("esimBuyStore", ["orderDetail"]),
    ...mapState("headerStore", ["title"]),
    ...mapState("verificationInfoStore", [
      "itemPassportStore",
      "imgPassportStore",
    ]),
    ...mapState("verificationInfoStore", ["imgVisaStore"]),
    ...mapState("verificationInfoStore", ["itemFaceIdStore", "imgFaceIdStore"]),
  },
  mounted() {
    this.changeTitle(this.$t("esim_register_info"));
  },
  watch: {
    $route: {
      handler: function (value) {
        this.$store.dispatch("headerStore/setTitle", "esim_register_info");
      },
      immediate: true,
    },
    "$route.hash": {
      handler: function (id_step) {
        console.log("id_step");
        if (id_step) {
          if (id_step == "#front-side") {
            this.active = 0;
            this.imgCCCD = null;
          } else if (id_step == "#face-detect") {
            this.active = 2;
            this.$refs.faceIdComponent?.enableWebcam();
          }
        }
        console.log("this.active", this.active);
      },
      immediate: true,
    },
  },
  methods: {
    color_primary() {
      return CONSTANTS.color_primary;
    },
    stateAsObject(value) {
      return JSON.parse(JSON.stringify(value));
    },
    changeTitle(title) {
      const contentData = {
        title: title,
        color: "#ffffff",
        bgColor: this.color_primary(),
      };
      this.$bridge.callHandler("setBarTitle", contentData).then((data) => {});
    },
    setStep(index) {
      this.active = index;
    },
    handleNextSteps() {
      if (this.active < this.steps.length - 1) this.active++;
    },
    handlePreviousSteps() {
      if (this.active > 0) this.active--;
    },
    capturePhoto() {
      this.$refs.camera.capturePhoto();
    },
    async handlePhotoCaptured(image) {
      if (this.defaultParam) {
        let params = this.stateAsObject(this.defaultParam);
        if (image) {
          params.image = image.replace(/^data:image\/\w+;base64,/, "");
        }

        if (this.orderDetail) {
          params.isdn = this.orderDetail.esimIsdn;
        }

        if (this.profile) {
          let tempPhone = this.profile.phone.replace(/\D/g, "");
          params.msisdn = tempPhone;
          params.accountABA = this.profile.appId;
        }

        if (!this.orderDetail) return;

        // this.$store.dispatch("loadingStore/showLoading", { status: true });

        // CCCD
        this.$store.dispatch("loadingStore/showLoading", { status: true });
        if (this.active == 0) {
          await this.$store
            .dispatch("esimMetfoneStore/passportReaderV2EsimABA", params)
            .then((res) => {
              if (res) {
                let result = res.data;
                if (result && result.errorCode == 0) {
                  this.itemPassport = result;
                  this.imgPassport = image;
                  this.$store.dispatch(
                    "verificationInfoStore/setItemPassport",
                    result
                  );
                  this.$store.dispatch(
                    "verificationInfoStore/setImgPassport",
                    image
                  );
                } else {
                  this.$notify({
                    code: result.errorCode,
                    message: result.errorDecription,
                  });
                }
              }
            });
        } else if (this.active == 1) {
          this.imgVisa = image;
          this.$store.dispatch("verificationInfoStore/setImgVisa", image);
        }
      }
      this.$store.dispatch("loadingStore/showLoading", { status: false });
    },
    retakePhoto() {
      if (this.active == 0) {
        this.imgPassport = null;
      } else if (this.active == 1) {
        this.imgVisa = null;
      }
    },
    continueProcess() {
      this.active = this.active + 1;
    },

    async handleChildBase64Image(base64) {
      await this.callApiWithImage(base64);
    },

    async callApiWithImage(base64) {
      // console.log("base64 --> passport", base64)
      try {
        this.itemFaceId = null;
        this.imgFaceId = base64;
        if (!this.imgFaceId) return;

        if (this.defaultParam) {
          let params = this.stateAsObject(this.defaultParam);
          params = {
            ...params,
            image: this.imgFaceId.replace(/^data:image\/\w+;base64,/, ""),
          };

          if (this.orderDetail) {
            params.isdn = this.orderDetail.esimIsdn;
          }
          if (this.profile) {
            let tempPhone = this.profile.phone.replace(/\D/g, "");
            params.msisdn = tempPhone;
            params.accountABA = this.profile.appId;
          }

          let provider = "";
          if (this.itemPassport) {
            provider = this.itemPassport.partner;
            params.provider = provider;
            params.transId = this.itemPassport.transid;
            params.pathFront = this.itemPassport.passportInfo.pathImage;
          }

          console.log("provider", provider);

          if (!provider) return;

          this.$store.dispatch("loadingStore/showLoading", { status: true });

          await this.$store
            .dispatch("esimMetfoneStore/faceMatchV2EsimABA", params)
            .then((res) => {
                if (res) {
                  let result = res.data;
                  if (result && result.errorCode == 0) {
                    // this.itemFaceId = result;
                    // this.isShowCardInfo = true;
                    this.$store.dispatch(
                      "verificationInfoStore/setItemFaceId",
                      result
                    );
                    this.$store.dispatch(
                      "verificationInfoStore/setImgFaceId",
                      this.imgFaceId
                    );
                    this.$router.push("/verification-info#passport");
                  } else {
                    this.$notify({
                      code: result.errorCode,
                      message: result.errorDecription,
                      onClose: () => {
                        this.$refs.faceIdComponent?.enableWebcam();
                      },
                    });
                  }
                }
              });


          /* 

          if (partner == "MASCOM") {
            await this.$store
              .dispatch("esimMetfoneStore/mascomFaceMatchV2EsimABA", params)
              .then((res) => {
                if (res) {
                  let result = res.data;
                  if (result && result.errorCode == 0) {
                    // this.itemFaceId = result;
                    // this.isShowCardInfo = true;
                    this.$store.dispatch(
                      "verificationInfoStore/setItemFaceId",
                      result
                    );
                    this.$store.dispatch(
                      "verificationInfoStore/setImgFaceId",
                      this.imgFaceId
                    );
                    this.$router.push("/verification-info#passport");
                  } else {
                    this.$notify({
                      code: result.errorCode,
                      message: result.errorDecription,
                      onClose: () => {
                        this.$refs.faceIdComponent?.enableWebcam();
                      },
                    });
                  }
                }
              });
          }
          if (partner == "BLUETECH") {
            await this.$store
              .dispatch("esimMetfoneStore/faceMatchV2EsimABA", params)
              .then((res) => {
                if (res) {
                  let result = res.data;
                  if (result && result.errorCode == 0) {
                    // this.itemFaceId = result;
                    // this.isShowCardInfo = true;
                    this.$store.dispatch(
                      "verificationInfoStore/setItemFaceId",
                      result
                    );
                    this.$store.dispatch(
                      "verificationInfoStore/setImgFaceId",
                      this.imgFaceId
                    );
                    this.$router.push("/verification-info#passport");
                  } else {
                    this.$notify({
                      code: result.errorCode,
                      message: result.errorDecription,
                      onClose: () => {
                        this.$refs.faceIdComponent?.enableWebcam();
                      },
                    });
                  }
                }
              });
          }
          */

        }
        this.$store.dispatch("loadingStore/showLoading", { status: false });
      } catch (error) {
        console.error("Error API:", error);
      }
    },
  },
};
</script>

<style>
.step-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  padding: 50px 0;
}

@media (max-width: 374px) {
  .step-container {
    padding: 30px 0 !important;
  }
}

.step-container .step {
  display: flex;
  justify-content: center;
  gap: 3px;
  min-width: fit-content;
}

.step-container .step p {
  margin: 0;
}

.step-container .step .step-number {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: rgba(217, 217, 217, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(16, 113, 110, 0.7);
  font-size: 12px;
}

.step-container .step .step-name {
  color: rgba(217, 217, 217, 0.7);
  font-size: 14px;
}

.step-container .step-line {
  width: 15px;
  height: 2px;
  background-color: rgba(217, 217, 217, 0.7);
}

.step-container .step-line.active {
  background-color: #fff;
}

.step-container .step.active .step-number {
  background-color: #fff;
  color: #10716d;
}

.step-container .step.active .step-name {
  color: #fff;
}

/* Custom image font */
.cs-image-font .van-image__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.capture-screen {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #fff;
  display: flex;
  align-items: center;
}

/* Cusotm button */

.btn-capture-photo {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  border: 3px solid #fff;
}

.bg-face-detect {
  background-color: #fff;
  width: 100%;
  min-height: 100vh;
  height: 100%;
}

/* Change color */
.cs-steps .step .step-number {
  background-color: rgba(196, 22, 39, 0.3);
  color: #c41627;
}

.cs-steps .step .step-name {
  color: rgba(196, 22, 39, 0.3);
}

.cs-steps .step-line {
  height: 1px !important;
  background-color: #000 !important;
}

.cs-steps .step.active .step-number {
  background-color: rgba(196, 22, 39, 0.3);
  color: #c41627;
}

.cs-steps .step.active .step-name {
  color: #c41627;
}
</style>